export default 'Banque des Territoires : prêts bonifiés long terme (Édu-Prêt et offres associées) pour collectivités. Articulation avec primes CEE et Fonds vert.';
